import React, { useState } from 'react';

const VolunteerForm = ({ selectedAction, onCancel }) => {
    const [formData, setFormData] = useState({
        fullName: '',
        gender: '',
        age: '',
        education: '',
        occupation: '',
        location: '',
        mobile: '',
        email: '',
        languages: [],
        roles: [],
    });

    // State to toggle image size
    const [isImageClicked, setIsImageClicked] = useState(false);

    const actions = {
        1: {
            title: 'Sponsor for a child',
            imageSrc: 'https://pratibhaposhak.in/images/mentorship.jpg',
            description: (
                <div className="volunteer-text-container">
                    <ul className="volunteer-list">
                        <li>Mentors play the central role in this project. Each mentor is assigned a group of 10-12 students.</li>
                        <li>As a mentor, you will inspire your students to dream bigger.</li>
                        <li>Help your students see their own potential and develop self-confidence.</li>
                        <li>Conduct periodic motivating sessions to sustain their efforts and focus.</li>
                        <li>Strengthen the attitudes of curiosity-driven enquiry, careful listening, logical analysis, and thoughtful response.</li>
                        <li>Teach them not to be afraid of making mistakes.</li>
                    </ul>
                </div>
            )
        },
        2: {
            title: 'Sponsor a school kit',
            imageSrc: 'https://static.wixstatic.com/media/39c521_b9fb72290eac4e9381515cb0aff1a136~mv2.png/v1/fill/w_390,h_270,al_c,q_85,usm_0.66_1.00_0.01,enc_avif,quality_auto/School%20Kit%20Logo.png',
            description: 'Description for Teacher volunteer role goes here.'
        },
        3: {
            title: 'Sponsor Books and Study materials',
            imageSrc: '../Assests/books.png',
            description: 'Description for Sponsor role goes here.'
        },
        4: {
            title: 'Way to Give ( Money )',
            imageSrc: '../Assests/Give_money.png',
            description: 'Description for Intern role goes here.'
        },
    };

    // Handle form input changes
    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData((prevData) => ({ ...prevData, [name]: value }));
    };

    // Handle checkbox changes for multiple values
    const handleCheckboxChange = (e) => {
        const { name, value, checked } = e.target;
        setFormData((prevData) => {
            const updatedValues = checked
                ? [...prevData[name], value]
                : prevData[name].filter((item) => item !== value);
            return { ...prevData, [name]: updatedValues };
        });
    };

    // Handle form submission
    const handleSubmit = (e) => {
        e.preventDefault();
        console.log('Form Submitted', formData);
    };

    // Handle form reset
    const handleReset = () => {
        setFormData({
            fullName: '',
            gender: '',
            age: '',
            education: '',
            occupation: '',
            location: '',
            mobile: '',
            email: '',
            languages: [],
            roles: [],
        });
    };

    const handleImageClick = () => {
        setIsImageClicked((prev) => !prev);
    };

    return (
        <div className="form-container">
            <div className="form-header">
                <div className="image-text-container" style={{ display: 'flex', alignItems: 'center' }}>
                    <div className="image-container" style={{ flex: 1, marginRight: '20px' }}>
                        <img
                            src={actions[selectedAction].imageSrc}
                            alt={actions[selectedAction].title}
                            className="form-image"
                            onClick={handleImageClick}
                            style={{
                                width: isImageClicked ? '250%' : '250%',
                                height: 'auto',
                                transition: 'width 0.5s ease',
                                marginLeft: '-170px',
                                display: 'block',
                            }}
                        />
                    </div>
                    <div className="text-container" style={{ flex: 2 }}>
                        <h3 className="form-title">{actions[selectedAction].title}</h3>
                        <div className="form-description">{actions[selectedAction].description}</div>
                    </div>
                </div>
            </div>
            <hr />
            <hr className="form-hr" />
            <h2 className="custom-heading">Expression of Interest</h2>
            <hr className="form-hr" />
            <form className="form-content" onSubmit={handleSubmit}>
                <div>
                    <label>Your Full Name</label>
                    <input
                        type="text"
                        name="fullName"
                        value={formData.fullName}
                        onChange={handleInputChange}
                        placeholder="Your full name"
                    />
                </div>
                <div>
                    <label>Gender</label>
                    <div className="radio-group">
                        <label><input type="radio" name="gender" value="male" onChange={handleInputChange} /> Male</label>
                        <label><input type="radio" name="gender" value="female" onChange={handleInputChange} /> Female</label>
                        <label><input type="radio" name="gender" value="others" onChange={handleInputChange} /> Others</label>
                    </div>
                </div>

                <div>
                    <label>Age</label>
                    <select name="age" value={formData.age} onChange={handleInputChange}>
                        <option value="below_40">Below 40 Years</option>
                        <option value="40_to_60">40-60 Years</option>
                        <option value="above_60">Above 60 Years</option>
                    </select>
                </div>
                <div>
                    <label>Education</label>
                    <input
                        type="text"
                        name="education"
                        value={formData.education}
                        onChange={handleInputChange}
                        placeholder="Education Details"
                    />
                </div>
                <div>
                    <label>Occupation</label>
                    <input
                        type="text"
                        name="occupation"
                        value={formData.occupation}
                        onChange={handleInputChange}
                        placeholder="Occupation Details"
                    />
                </div>
                <div>
                    <label>Where do you live?</label>
                    <input
                        type="text"
                        name="location"
                        value={formData.location}
                        onChange={handleInputChange}
                        placeholder="City/Town/Village Details"
                    />
                </div>
                <div>
                    <label>Your Mobile Number</label>
                    <input
                        type="text"
                        name="mobile"
                        value={formData.mobile}
                        onChange={handleInputChange}
                        placeholder="Mobile Number"
                    />
                </div>
                <div>
                    <label>Email ID</label>
                    <input
                        type="email"
                        name="email"
                        value={formData.email}
                        onChange={handleInputChange}
                        placeholder="Email ID"
                    />
                </div>
                <div>
                    <label>Languages you can speak</label>
                    <div className="checkbox-group">
                        <label><input type="checkbox" name="languages" value="kannada" onChange={handleCheckboxChange} /> Kannada</label>
                        <label><input type="checkbox" name="languages" value="english" onChange={handleCheckboxChange} /> English</label>
                        <label><input type="checkbox" name="languages" value="hindi" onChange={handleCheckboxChange} /> Hindi</label>
                        <label><input type="checkbox" name="languages" value="marathi" onChange={handleCheckboxChange} /> Marathi</label>
                    </div>
                </div>

                <div>
                    <label>What role are you interested in?</label>
                    <div className="checkbox-group">
                        <label><input type="checkbox" name="roles" value="mentor" onChange={handleCheckboxChange} /> Mentor</label>
                        <label><input type="checkbox" name="roles" value="teacher" onChange={handleCheckboxChange} /> Teacher</label>
                        <label><input type="checkbox" name="roles" value="sponsor" onChange={handleCheckboxChange} /> Sponsor</label>
                        <label><input type="checkbox" name="roles" value="intern" onChange={handleCheckboxChange} /> Intern</label>
                    </div>
                </div>
                <div className="form-content">
                    <div className="button-container">
                        <button type="submit" className="btn submit-btn">Submit</button>
                        <button type="reset" className="btn reset-btn" onClick={handleReset}>Reset</button>
                        <button type="button" className="btn cancel-btn" onClick={onCancel}>Cancel</button>
                    </div>
                </div>
            </form>
            <hr />
        </div>
    );
};

export default VolunteerForm;
